"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@emotion/core");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const Monogram_1 = require("./Monogram");
const fadeInOut = core_1.keyframes `
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.1;
  }

  100% {
    opacity: 1;
  }
`;
const LoadingWrapper = styled_1.default(react_core_1.Box) `
  padding-top: 96px;
  flex: 1 1 auto;
  min-height: 512px;
  background-color: ${styled_tools_1.prop('theme.gray6')};
`;
const MonogramWrapper = styled_1.default(react_core_1.Box) `
  display: grid;
  width: 100%;
  flex-direction: column;
  place-items: center;
  place-content: center;
  grid:
    'monogram' auto
    'text' auto
    / auto;
  grid-gap: 16px;
`;
const StyledMonogram = styled_1.default(Monogram_1.Monogram) `
  animation: ${fadeInOut} 1.5s linear infinite;
`;
exports.Loading = () => (React.createElement(LoadingWrapper, null,
    React.createElement(MonogramWrapper, null,
        React.createElement(StyledMonogram, null))));

//# sourceMappingURL=Loading.js.map
